var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBtn)?_c('v-btn',_vm._b({staticClass:"main-btn px-6",attrs:{"height":"40","min-width":_vm.minWidth,"elevation":"0","outlined":_vm.outlined,"color":_vm.color,"target":_vm.target},on:{"click":_vm.emitClick}},'v-btn',_vm.link,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }